import React from 'react';

const DreamSection = () => {
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-8 lg:px-16 bg-gradient-to-br from-amber-50 via-white to-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8">
            Crafting Dreams Into Reality
          </h2>
          <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto text-gray-600 leading-relaxed">
            With over 15 years of excellence in interior design, we transform spaces into living masterpieces that reflect your unique style and personality.
          </p>
        </div>
        
        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {/* Personalized Design */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-amber-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mb-6">
              <span className="material-symbols-outlined text-white text-2xl">palette</span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Personalized Design</h3>
            <p className="text-gray-600 leading-relaxed">
              Every project is a unique reflection of our client's vision, tailored to match their lifestyle and preferences perfectly.
            </p>
          </div>
          
          {/* Expert Craftsmanship */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-amber-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mb-6">
              <span className="material-symbols-outlined text-white text-2xl">construction</span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Expert Craftsmanship</h3>
            <p className="text-gray-600 leading-relaxed">
              Our skilled team brings decades of experience to every project, ensuring exceptional quality and attention to detail.
            </p>
          </div>
          
          {/* Timeless Elegance */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-amber-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mb-6">
              <span className="material-symbols-outlined text-white text-2xl">diamond</span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">Timeless Elegance</h3>
            <p className="text-gray-600 leading-relaxed">
              We create spaces that stand the test of time, blending contemporary trends with classic design principles.
            </p>
          </div>
        </div>
        
        {/* Process Steps */}
        <div className="mb-12 sm:mb-16">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-8 sm:mb-12">Our Design Process</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl font-bold">1</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Consultation</h4>
              <p className="text-gray-600 text-sm">Understanding your vision and requirements</p>
            </div>
            
            {/* Step 2 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl font-bold">2</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Design Planning</h4>
              <p className="text-gray-600 text-sm">Creating detailed design concepts and layouts</p>
            </div>
            
            {/* Step 3 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl font-bold">3</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Implementation</h4>
              <p className="text-gray-600 text-sm">Bringing designs to life with expert execution</p>
            </div>
            
            {/* Step 4 */}
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl font-bold">4</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Final Reveal</h4>
              <p className="text-gray-600 text-sm">Presenting your transformed dream space</p>
            </div>
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="text-center">
          <button className="px-8 py-4 rounded-full font-semibold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 transition-all duration-300 hover:scale-105 shadow-xl text-sm sm:text-base md:text-lg">
            Start Your Dream Project
          </button>
          <p className="mt-4 text-gray-600 text-sm sm:text-base">
            Let's create something extraordinary together
          </p>
        </div>
      </div>
    </section>
  );
};

export default DreamSection;
